import React, { useContext, useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import Slider from "react-slick";
import toast from "react-hot-toast";
import moment from "moment";

import { getLambdaResolver, listLambdaResolver, sendEmailTemplate, getDashboardData } from "../../graphql/queries";
import { crudPropertyUnitLease } from "../../graphql/mutations";
import { SpinnerLoading } from "../../components/Loadings";
import MaintenanceCard from "./components/MaintenanceCard";
import { MyDropzone } from "../dashboard/components/Dropzone";
import MaintenanceHistory from "./components/MaintenanceHistory";
import { Storage } from "aws-amplify";

import { createRecordTB, fetchDashboardData, filterRDSDataFn, getRdsFN } from "../../Utility/ApiService";
import { getBase64, getId, compressImage } from "../../Utility";
import { Context } from "../../Utility/ContextManager";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 6,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1550,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
      },
    },
  ],
};

const Maintenance = () => {
  const [probDetail, setProbDetail] = useState("");
  const [maintenanceName, setMaintenanceName] = useState("");
  const [maintenanceType, setMaintenanceType] = useState("");
  const [maintenanceAttachments, setMaintenanceAttachments] = useState([]);
  const [allMaintenanceTypes, setAllMaintenanceTypes] = useState([]);
  const [maintenanceTypeId, setMaintenanceTypeId] = useState("");
  const [allMaintenances, setAllMaintenances] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showMaintainceHistory, setShowMaintainceHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(87);
  const [errorMessage, setErrorMessage] = useState();
  const [propertyDetails, setPropertyDetails] = useState();
  const [collaborators, setCollaborators] = useState([]);
  const removeDocs = React.useRef(null);
  const { user } = useContext(Context);

  useEffect(() => {
    fetchAllMaintenanceTypes();
    fetchAllMaintenances();
    getPropertyData();
  }, []);

  const getPropertyData = async () => {
    try {
      setLoading(true);
      const data = await fetchDashboardData(user?.id);
      setPropertyDetails(data);
      const collabroatorList = await API.graphql(
        graphqlOperation(getDashboardData, {
          name: "getPortfolioCollaboratorsByPortfolioId",
          data: JSON.stringify({ portfolioId: data?.portfolio_id }),
        })
      );
      const allCollaborators = JSON.parse(collabroatorList?.data?.getDashboardData?.response || "[]");

      const filteredCollaborators = allCollaborators.filter((collaborator) => collaborator?.permission !== "View Only");

      //parse the response
      setCollaborators(filteredCollaborators);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error-----", error);
      toast.error(error.message || "Something went wrong please try again later");
    }
  };

  const fetchAllMaintenances = async () => {
    setLoading(true);
    filterRDSDataFn("maint", "tntId", user?.id)
      .then((data) => {
        const sortedDates = data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setAllMaintenances(sortedDates);
        setLoading(false);
      })
      .catch((err) => {
        console.log("fetchAllMaintenances ", err);
        setLoading(false);
      });
  };

  const fetchAllMaintenanceTypes = async () => {
    await API.graphql(graphqlOperation(listLambdaResolver, { table: "MaintananceType" }))
      .then((res) => {
        setAllMaintenanceTypes(JSON.parse(res.data.listLambdaResolver.response || "[]"));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const chooseMaintenance = (type, name, id) => {
    setMaintenanceName(name);
    setMaintenanceType(type);
    setMaintenanceTypeId(id);
  };
  const getFileExtension = (filename) => {
    return filename.substring(filename.lastIndexOf(".") + 1, filename.length) || filename;
  };

  const showError = (message) => {
    setErrorMessage(message);
    setTimeout(() => {
      setErrorMessage();
    }, 3000);
  };

  const onHandleSend = () => {
    let extensions = [];
    for (let j = 0; j < maintenanceAttachments?.length; j++) {
      extensions[j] = getFileExtension(maintenanceAttachments[j]?.name);
    }
    for (let k = 0; k < extensions.length; k++) {
      if (
        extensions[k].toUpperCase() === "PNG" ||
        extensions[k].toUpperCase() === "JPG" ||
        extensions[k].toUpperCase() === "JPEG" ||
        extensions[k].toUpperCase() === "PDF" ||
        extensions[k].toUpperCase() === "DOC" ||
        extensions[k].toUpperCase() === "DOCX"
      ) {
      } else {
        showError("You can only select images, pdf or docx files");
        return;
      }
    }

    setLoading(true);
    const typeExists = allMaintenanceTypes.some((user) => user.maintanance_type === maintenanceType);
    console.log("allMaintenanceTypes", typeExists);
    if (typeExists === true) {
      createMaintenanceReq();
    } else {
      createMaintenanceType();
    }
  };

  const createMaintenanceType = async () => {
    const maintenanceTypeObj = {
      id: maintenanceTypeId,
      maintanance_type: maintenanceType,
    };
    await createRecordTB("MaintananceType", maintenanceTypeObj)
      .then(() => {
        createMaintenanceReq();
      })
      .catch((err) => {
        console.log("err ", err);
        setLoading(false);
      });
  };

  const fetchPropertyManager = async (data) => {
    try {
      // const res = await API.graphql(graphqlOperation(getLambdaResolver, { table: "User", id: user?.created_by }));
      const res = await getRdsFN("tbSelect", {
        source: "usr",
        id: user?.created_by,
      });

      const propertyManagerInfo = res[0];
      if (data?.pm_first_name && data?.pm_first_name !== "") propertyManagerInfo.first_name = data?.pm_first_name;
      if (data?.pm_last_name && data?.pm_last_name !== "") propertyManagerInfo.last_name = data?.pm_last_name;
      if (data?.pm_phone && data?.pm_phone !== "") propertyManagerInfo.phone = data?.pm_phone;
      if (data?.pm_email && data?.pm_email !== "") propertyManagerInfo.email = data?.pm_email;
      return propertyManagerInfo;
    } catch (error) {
      console.log("error fetchPropertyManager ", error);
      setLoading(false);
    }
  };
  const createMaintenanceReq = async () => {
    try {
      const maintenanceId = getId();
      const maintenanceObj = {
        id: maintenanceId,
        maintanance_type_name: maintenanceName,
        maintanance_type_id: maintenanceTypeId,
        property_unit_id: propertyDetails?.property_unit_id,
        status: "OPEN",
        reporter: `${user?.first_name} ${user?.last_name}`,
        created_by: user?.id,
        message: probDetail,
        tenant_id: user?.id,
        date: moment().format("YYYY-MM-DD"),
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        last_modified: moment().format("YYYY-MM-DD HH:mm:ss"),
        active: 1,
      };
      await createRecordTB("Maintanance", maintenanceObj);
      await onSendEmail(maintenanceId);

      fetchAllMaintenances();
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(error.message || error.errors[0].message || "Something went wrong please try again later");
    }
  };

  const addPhotosToS3 = async (maintenanceAttachments, maintenanceId) => {
    try {
      await Promise.all(
        maintenanceAttachments.map(async (file) => {
          // Replace spaces and '?' in the file name with underscores
          const sanitizedFileName = file.name.replace(/[\s?]/g, "_");
          const fileExtension = sanitizedFileName.split(".").pop(); // Get the file extension
          const documentUrl = `${sanitizedFileName.replace(`.${fileExtension}`, "")}-${getId()}.${fileExtension}`;
          const compressedFile = await compressImage(file); // Compress the file
          await Storage.put(`property/${documentUrl}`, compressedFile, {
            level: "public",
            contentType: file.type,
          });

          const payload = {
            action: "add_maintanance_document",
            maintanance_id: maintenanceId,
            tenant_id: user?.id,
            document_url: documentUrl,
            document_name: sanitizedFileName,
            created_by: user?.id,
          };

          const res = await API.graphql(
            graphqlOperation(crudPropertyUnitLease, {
              data: JSON.stringify(payload),
            })
          );
          const responseData = res.data.crudPropertyUnitLease;
        })
      );
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  };

  const onSendEmail = async (maintenanceId) => {
    setLoading(true);
    const propDetails = await fetchDashboardData(user?.id);
    const propertyManagerInfo = await fetchPropertyManager(propDetails);
    const maintenance_name = `${maintenanceName} - ${propDetails?.address1}`;
    try {
      //await API.graphql(graphqlOperation(getLambdaResolver, { table: "User", id: user?.created_by }));
      const attachments = await Promise.all(
        maintenanceAttachments.map(async (file) => {
          const compressedFile = await compressImage(file); // Compress the file
          return {
            filename: file.name,
            path: await getBase64(compressedFile), // Use compressed file
            // contentType: file.type,
          };
        })
      );
      await addPhotosToS3(maintenanceAttachments, maintenanceId);
      const collaboratorEmails = collaborators
        .filter((collab) => collab.active) // Include only active collaborators
        .map((collab) => collab.email) // Extract the email field
        .join(","); // Join emails with commas

      const sendToEmail = [
        propDetails?.pm_email || propertyManagerInfo?.email, // Add property manager email
        collaboratorEmails, // Add collaborator emails
      ]
        .filter(Boolean) // Remove any undefined or null values
        .join(","); // Join with commas

      const res = await API.graphql(
        graphqlOperation(sendEmailTemplate, {
          id: user?.created_by,
          role: "User",
          code: "MAINTENANCENEW",
          attachments: JSON.stringify(attachments),
          data: JSON.stringify({
            first_name: `${user?.first_name}`,
            last_name: `${user?.last_name}`,
            maintenance_name: maintenanceName,
            property_address: `${propDetails?.address1}`,
            unit_name: `${propDetails?.property_unit_name}`,
            message: probDetail.replace(/<[^>]*>?/gm, ""),
            sendToEmail: sendToEmail,
          }),
        })
      );

      setLoading(false);

      if (res.data.sendEmailTemplate.status === 200) {
        setShowSuccessMessage(true);
        resetValues();
        setTimeout(() => {
          setShowSuccessMessage(false);
        }, 2000);
      } else {
        toast.error(res.data.sendEmailTemplate.response);
      }
    } catch (error) {
      setLoading(false);
      console.log("Confirmation Email Err", error);
      toast.error(error.message || error.errors[0].message || "Something went wrong please try again later");
    }
  };

  const resetValues = () => {
    setProbDetail();
    setMaintenanceAttachments([]);
    setMaintenanceType();
    setMaintenanceName();
    setMaintenanceTypeId();
    setRefreshKey(Math.random());
    // removeDocs.current();
    removeDocs.current.getAlert();
    // document.getElementById("upload").value = "";
  };

  const enableSend = () => {
    if (!probDetail || !maintenanceName) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div>
      {/* START layout-wrapper */}
      {loading && (
        <div className="loadingSpinner">
          <SpinnerLoading />
        </div>
      )}
      {!showMaintainceHistory && (
        <div>
          {showSuccessMessage && (
            <div className="errors">
              <div className="error success">Your maintenance request was sent</div>
            </div>
          )}

          {errorMessage && (
            <div className="errors">
              <div className="error warning">
                {errorMessage}
                <a
                  href="#"
                  className="close-error"
                  onClick={(e) => {
                    e.preventDefault();
                    setErrorMessage();
                  }}
                >
                  <img src={require("../../assets/images/close.svg").default} alt="" />
                </a>
              </div>
            </div>
          )}

          <div>
            {/* START page title */}
            <div className="row">
              <div className="col-xl-5 col-lg-4">
                <div className="page-title">
                  <h2>Maintenance</h2>
                </div>
              </div>
              <div className="col-xl-7 col-lg-8 text-start text-lg-end">
                <button onClick={() => setShowMaintainceHistory(true)} className="btn history-maintenance-btn">
                  Maintenance History
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="maintenance-request">
                  <form>
                    <div>
                      <label className="title">What kind of maintenance request do you have?</label>
                      <Slider className="maintenanceSlider" {...settings}>
                        {[
                          { title: "Plumbing", name: "plumbing" },
                          {
                            title: "Landscaping and Irrigation",
                            name: "landscaping_Irrigation",
                          },
                          {
                            title: "Heating and Cooling",
                            name: "heating_cooling",
                          },
                          {
                            title: "Lighting and Electrical",
                            name: "lighting_electrical",
                          },
                          {
                            title: "Doors, Windows, Flooring",
                            name: "Doors_Windows_Flooring",
                          },
                          { title: "Pest Control", name: "pest_control" },
                          { title: "Other", name: "other" },
                          { title: "Roof Repair", name: "roof_repair" },
                        ].map((item, i) => (
                          <li key={i} className={`maintenanceList ${maintenanceName === item.title ? "show" : "hide"}`}>
                            <MaintenanceCard
                              id={`mr${i + 1}`}
                              imgsrc={require(`../../assets/images/${item.name}.svg`).default}
                              title={item.title.replace(" and", " & ")}
                              onClick={() => {
                                chooseMaintenance(item.name, item.title, i + 1);
                              }}
                              checked={maintenanceName === item.title ? true : false}
                            />
                          </li>
                        ))}
                      </Slider>
                      <ul className="maintenanceListMobile">
                        {[
                          { title: "Plumbing", name: "plumbing" },
                          {
                            title: "Landscaping and Irrigation",
                            name: "landscaping_Irrigation",
                          },
                          {
                            title: "Heating and Cooling",
                            name: "heating_cooling",
                          },
                          {
                            title: "Lighting and Electrical",
                            name: "lighting_electrical",
                          },
                          {
                            title: "Doors, Windows, Flooring",
                            name: "Doors_Windows_Flooring",
                          },
                          { title: "Pest Control", name: "pest_control" },
                          { title: "Other", name: "other" },
                          { title: "Roof Repair", name: "roof_repair" },
                        ].map((item, i) => (
                          <li key={i} className={`maintenanceList ${maintenanceName === item.title ? "show" : "hide"}`}>
                            <MaintenanceCard
                              id={`mr${i + 1}`}
                              imgsrc={require(`../../assets/images/${item.name}.svg`).default}
                              title={item.title.replace(" and", " & ")}
                              onClick={() => {
                                chooseMaintenance(item.name, item.title, i + 1);
                              }}
                              checked={maintenanceName === item.title ? true : false}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-7">
                        <div className="mb-4">
                          <label htmlFor="des" className="title">
                            Describe your problem
                          </label>
                          <textarea
                            key={refreshKey}
                            id="des"
                            className="w-100 form-control describe-issue"
                            placeholder="Please provide details about the maintenance problem you're reporting"
                            value={probDetail}
                            defaultValue={probDetail}
                            onChange={(e) => {
                              setProbDetail(e.target.value);
                            }}
                          />
                        </div>
                        <div className="uploadDocuments">
                          <MyDropzone
                            text="+ Upload Photos/Documents"
                            isMaintenance={true}
                            setMaintenanceAttachments={setMaintenanceAttachments}
                            ref={removeDocs}
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div style={{ marginTop: 25 }} className="col-12 text-start text-lg-end">
                <button
                  style={{ marginRight: 30 }}
                  onClick={resetValues}
                  type="button"
                  className="btn btn-warning sendBtn"
                >
                  Cancel
                </button>
                <button
                  disabled={enableSend() === true ? true : false}
                  type="button"
                  className="btn btn-primary btn-send ms-2"
                  onClick={onHandleSend}
                >
                  <img src={require("../../assets/images/send.svg").default} className="me-2" /> Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showMaintainceHistory && (
        <MaintenanceHistory
          allMaintenances={allMaintenances}
          loading={loading}
          setShowMaintainceHistory={setShowMaintainceHistory}
        />
      )}
    </div>
  );
};

export default Maintenance;
